const ElementoAer = (props) => {

    const formato = 'text-center'

   
    return (<>
        <div className="w-full flex bg-zinc-200 flex-row justify-between"  onClick={e => props.setUpdData(props.obj)} key={props.obj.id}>
            <input 
                type="checkbox" 
                id={props.obj.id}  
                checked={props.obj.s}
                onChange={(e => props.elegir(props.obj.id))}
            />
             <div className="px-5 grid grid-cols-7 w-full">
              <label>{props.obj.apellido===props.obj.apellido.substring(0,13) ? props.obj.apellido : props.obj.apellido.substring(0,13) + '...'}</label>
              <label>{props.obj.nombre}</label>
              <label className="col-span-2">{props.obj.email.substring(0,30)===props.obj.email ? props.obj.email : props.obj.email.substring(0,30) + '...'}</label>
              <label>{props.obj.documento}</label>
              <label>{props.obj.telefono}</label>
              <label className={formato}>{props.evento.prefijoqr + props.obj.id.toString().padStart(parseInt(props.evento.cifrasqr),'0')}</label>
            </div>
        </div>
        </>)
}

export default ElementoAer